import {
  GetDocumentHistoriesRequest,
  GetDocumentHistoriesResponse,
  PatrickServiceClient,
} from '@policyfly/protobuf/patrick'

import { devtools } from '@/plugins/devtools/api'

import type { ApiVariableEndpoints, CreateEndpointParams } from '@/stores/api'

export interface DocReviewApiEndpoints {
  /**
   * Retrieves preview eligibility and version histories for the requested attachments.
   */
  list: (attachmentIds: string[]) => Promise<GetDocumentHistoriesResponse>
}

export const createDocReviewEndpoints = (params: CreateEndpointParams): ApiVariableEndpoints<DocReviewApiEndpoints> => {
  const patrickServiceClient = new PatrickServiceClient(params.transport)

  const listDjango: DocReviewApiEndpoints['list'] = async () => {
    throw new Error('Document review is not supported on Django')
  }

  const listGrpc: DocReviewApiEndpoints['list'] = async (attachmentIds) => {
    const request = GetDocumentHistoriesRequest.create({ attachmentIds })
    const { response } = await patrickServiceClient.getDocumentHistories(request)

    devtools.logGrpc({
      description: 'Get Document Histories',
      messages: [
        { type: GetDocumentHistoriesRequest, key: 'request', message: request },
        { type: GetDocumentHistoriesResponse, key: 'response', message: response },
      ],
    })

    return response
  }

  return {
    django: { list: listDjango },
    grpc: { list: listGrpc },
  }
}
